function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0xfec59a;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;










    var itemsPositionsObject = { p_03_6: { x: 507, y: 351, w: 107, h: 151, n: "p_03_6" }, p_03_5: { x: 104, y: 351, w: 117, h: 141, n: "p_03_5" }, p_03_4: { x: 308, y: 301, w: 125, h: 142, n: "p_03_4" }, p_03_3: { x: 444, y: 204, w: 125, h: 142, n: "p_03_3" }, p_03_2: { x: 188, y: 188, w: 109, h: 145, n: "p_03_2" }, p_03_1: { x: 346, y: 85, w: 114, h: 140, n: "p_03_1" }, p_03_0: { x: 38, y: 104, w: 132, h: 142, n: "p_03_0" }, o_03_6: { x: 86, y: 443, w: 176, h: 48, n: "o_03_6" }, o_03_5: { x: 383, y: 450, w: 273, h: 64, n: "o_03_5" }, o_03_4: { x: 332, y: 164, w: 170, h: 80, n: "o_03_4" }, o_03_3: { x: 296, y: 370, w: 142, h: 98, n: "o_03_3" }, o_03_2: { x: 419, y: 296, w: 166, h: 55, n: "o_03_2" }, o_03_1: { x: 92, y: 270, w: 299, h: 102, n: "o_03_1" }, o_03_0: { x: 8, y: 190, w: 170, h: 70, n: "o_03_0" }, p_02_6: { x: 309, y: 128, w: 107, h: 151, n: "p_02_6" }, p_02_5: { x: 485, y: 350, w: 117, h: 141, n: "p_02_5" }, p_02_4: { x: 407, y: 269, w: 125, h: 142, n: "p_02_4" }, p_02_3: { x: 246, y: 300, w: 125, h: 142, n: "p_02_3" }, p_02_2: { x: 113, y: 244, w: 109, h: 145, n: "p_02_2" }, p_02_1: { x: 545, y: 99, w: 114, h: 140, n: "p_02_1" }, p_02_0: { x: 123, y: 108, w: 132, h: 142, n: "p_02_0" }, o_02_6: { x: 229, y: 389, w: 176, h: 48, n: "o_02_6" }, o_02_5: { x: 358, y: 440, w: 273, h: 64, n: "o_02_5" }, o_02_4: { x: 400, y: 340, w: 170, h: 80, n: "o_02_4" }, o_02_3: { x: 113, y: 310, w: 142, h: 98, n: "o_02_3" }, o_02_2: { x: 528, y: 184, w: 166, h: 55, n: "o_02_2" }, o_02_1: { x: 213, y: 209, w: 299, h: 102, n: "o_02_1" }, o_02_0: { x: 99, y: 190, w: 170, h: 70, n: "o_02_0" }, p_01_6: { x: 90, y: 305, w: 107, h: 151, n: "p_01_6" }, p_01_5: { x: 213, y: 216, w: 117, h: 141, n: "p_01_5" }, p_01_4: { x: 124, y: 123, w: 125, h: 142, n: "p_01_4" }, p_01_3: { x: 268, y: 317, w: 125, h: 142, n: "p_01_3" }, p_01_2: { x: 502, y: 211, w: 109, h: 145, n: "p_01_2" }, p_01_1: { x: 393, y: 85, w: 114, h: 140, n: "p_01_1" }, p_01_0: { x: 384, y: 254, w: 132, h: 142, n: "p_01_0" }, o_01_6: { x: 75, y: 408, w: 176, h: 48, n: "o_01_6" }, o_01_5: { x: 255, y: 345, w: 273, h: 64, n: "o_01_5" }, o_01_4: { x: 268, y: 388, w: 170, h: 80, n: "o_01_4" }, o_01_3: { x: 502, y: 283, w: 142, h: 98, n: "o_01_3" }, o_01_2: { x: 202, y: 297, w: 166, h: 55, n: "o_01_2" }, o_01_1: { x: 308, y: 164, w: 299, h: 102, n: "o_01_1" }, o_01_0: { x: 94, y: 204, w: 170, h: 70, n: "o_01_0" }, mare: { x: 8, y: 85, w: 726, h: 429, n: "mare" } };
    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);

    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function onStartGame() {

    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 800);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {

        gameData.numItems = 1;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(380, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('boe', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        //   game.gameContainer.addChild(counter.container);
    }


    function positionGameItems() {
        sprites.btn_gioca.x = 973;
        sprites.btn_gioca.y = 460;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}


function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;

    //
    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    var buttonsContainer = new Container();

    var cursorIndex = 0;
    var gameIndex = 0;

    buttonsContainer.interactive = true;
    buttonsContainer.on('pointertap', onClick);

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);

    var sceneElements = {};
    var scaffoldsNames = ['01', '02', '03'];
    var flagIndexes = [];
    var boeIndexes = [];
    var currentScaffoldName;
    var flags = [];
    var selectedBoa1 = -1;
    var selectedBoa2 = -1;
    initScene();

    function initScene() {
        var i, ii, iii;
        var itemName;
        var spriteItem;
        var pos;

        var graphics;

        spriteItem = game.sprites.mare;
        pos = positions.mare;
        spriteItem.position.set(pos.x, pos.y);
        container.addChild(spriteItem);
        sceneElements.mare = spriteItem;

        for (i = 0; i < 7; i++) {
            boeIndexes.push(i);
            var boa = new Container();
            sceneElements['boa_' + i] = boa;
            boa.pivot.set(60, 72);
            for (ii = 0; ii < 12; ii++) {
                var flag = new Sprite(game.sprites['bandiera_' + ii].texture);
                flag.position.set(0, 0);
                boa.addChild(flag);
                sceneElements['bandiera_' + i + '_' + ii] = flag;
                flags.push(flag);
                if (i === 0) {
                    flagIndexes.push(ii);
                }

            }

            spriteItem = new Sprite(game.sprites['onda_' + i].texture);
            sceneElements['onda_' + i] = spriteItem;
            container.addChild(spriteItem);


            spriteItem = new Sprite(game.sprites.el.texture);
            spriteItem.position.set(0, 37);
            sceneElements['el_' + i] = spriteItem;
            boa.addChild(spriteItem);

            spriteItem = new Sprite(game.sprites.el_sel.texture);
            spriteItem.position.set(0, 37);
            sceneElements['el_sel_' + i] = spriteItem;
            spriteItem.alpha = 0;
            boa.addChild(spriteItem);



            spriteItem = new Graphics();
            spriteItem.beginFill(0x706f5a);
            spriteItem.lineStyle(0, 0x000000);
            spriteItem.drawRect(0, 0, 119, 145);
            spriteItem.endFill();
            spriteItem.interactive = true;
            spriteItem.buttonMode = true;
            sceneElements['basic_' + i] = spriteItem;
            spriteItem.alpha = 0;
            boa.addChild(spriteItem);


            buttonsContainer.addChild(boa);
            //

        }

        container.addChild(buttonsContainer);

    }


    function clear() {


    }

    function reset() {
        scaffoldsNames = _.shuffle(scaffoldsNames);
        gameIndex = 0;
        setState('newScaffold');
    }

    function resetScaffolds() {
        var i, ii;
        cursorIndex = 0;

        for (i = 0; i < 7; i++) {
            var orderedIndex = boeIndexes[i];
            sceneElements['el_sel_' + orderedIndex].alpha = 0;
            sceneElements['el_' + orderedIndex].alpha = 1;
            sceneElements['basic_' + orderedIndex].visible = true;

            for (ii = 0; ii < 12; ii++) {
                if (i > 1) {
                    sceneElements['bandiera_' + orderedIndex + '_' + ii].visible = orderedIndex === flagIndexes[ii];
                } else {
                    sceneElements['bandiera_' + orderedIndex + '_' + ii].visible = boeIndexes[1] === flagIndexes[ii];
                }
            }

            var pos = positions['p_' + currentScaffoldName + '_' + i];
            var rot = Math.PI / 180 * (Math.floor(Math.random() * 18) * 2 - 15);
            sceneElements['boa_' + i].position.set(pos.x + 60, pos.y + 72);
            sceneElements['boa_' + i].rotation = (rot);

            pos = positions['o_' + currentScaffoldName + '_' + i];
            sceneElements['onda_' + i].position.set(pos.x, pos.y);
        }
        selectedBoa1 = -1;
        selectedBoa2 = -1;
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newScaffold':


                scaffoldsNames.push(scaffoldsNames.shift());

                currentScaffoldName = scaffoldsNames[0];
                flagIndexes = _.shuffle(flagIndexes);
                boeIndexes = _.shuffle(boeIndexes);


                resetScaffolds();


                break;
            case 'ready':

                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function onClick(e) {
        var i;
        var pos;
        if (currentState === "ready") {



            var btnIndex = -1;
            for (i = 0; i < 7; i++) {

                if (sceneElements['basic_' + i] === e.target) {
                    btnIndex = i;
                }
            }

            if (btnIndex === -1) {
                return false;
            }
            if (selectedBoa1 === -1) {
                selectedBoa1 = btnIndex;
            } else {
                selectedBoa2 = btnIndex;
            }
            setState('animating');

            tl.to(sceneElements['el_sel_' + btnIndex], 0.5, {
                pixi: { alpha: 1 }
            }).addCallback(selectionComplete);
            loopSequence = [renderAlways];
        }

    }



    function selectionComplete() {

        cursorIndex++;
        if (cursorIndex < 2) {
            setState('ready');
            loopSequence = [renderOnce];
        } else {

            var ok = boeIndexes[0] === selectedBoa1 && boeIndexes[1] === selectedBoa2 || boeIndexes[0] === selectedBoa2 && boeIndexes[1] === selectedBoa1;

            if (ok) {
                setState('animating');
                renderer.view.dispatchEvent(new Event('answerOk'));
                setTimeout(okComplete, 1000);


            } else {

                setState('animating');
                renderer.view.dispatchEvent(new Event('answerWrong'));
                tl.to(sceneElements['el_sel_' + selectedBoa1], 0.25, {
                    pixi: { alpha: 0 }
                }).to(sceneElements['el_sel_' + selectedBoa2], 0.25, {
                    pixi: { alpha: 0 }
                }, "-=0.25").addCallback(wrongComplete);
                loopSequence = [renderAlways];
                cursorIndex = 0;
                selectedBoa1 = -1;
                selectedBoa2 = -1;
            }

        }



    }

    function okComplete() {

        gameIndex++;
        if (gameIndex < 1) {
            setState('newScaffold');
        }

        theGame.cycleGame();
        loopSequence = [renderOnce];


    }

    function wrongComplete() {
        theGame.cycleGame();
        loopSequence = [renderOnce];
        setState('ready');
    }
}